import { JobItem, JobPageItem, JobSearch } from '@types'

import { booleanToHumanString, countJobPageView, sendEventToAnalytics } from '@lib/helpers/client'

type JobEventPayload = {
  event_label: string
  hasBenefits: string
  jobCompanyName: string
  jobFeed: string
  jobGroupCategory: string
  jobId: string
  jobSource: string
  jobTitle: string
  non_interaction: boolean
  searchLocationId: string
  searchLocationName: string
  searchLocationType: string
  searchMacroRole: string
  searchMicroRole: string
  search_strategy: string
  position?: string
}

function createJobEventPayload(
  job: JobItem | undefined,
  search: JobSearch,
  serpPositionClicked?: string,
): JobEventPayload {
  return {
    event_label: job?.id || '',
    hasBenefits: booleanToHumanString(Number(job?.benefits?.length) > 0),
    jobCompanyName: job?.companyName || '',
    jobFeed: job?.feed || '',
    jobGroupCategory: job?.groupCategory || '',
    jobId: job?.id || '',
    jobSource: job?.source || '',
    jobTitle: job?.title || '',
    non_interaction: true,
    searchLocationId: search.location.id || '',
    searchLocationName: search.location.name || '',
    searchLocationType: search.location.type || '',
    searchMacroRole: search.job.macro || '',
    searchMicroRole: search.job.micro || '',
    search_strategy: search.sort || '',
    ...(serpPositionClicked && { position: serpPositionClicked }),
  }
}

export function jobApplyWithSonicApplyButtonClickedEvent(job: JobItem, search: JobSearch): void {
  const eventName = 'web_apply_with_sonic_apply_button_clicked'
  const payload: JobEventPayload = createJobEventPayload(job, search)
  sendEventToAnalytics(eventName, payload)
}

export function jobPageViewEvent(job: JobPageItem | undefined, search: JobSearch, serpPositionClicked: string): void {
  const eventName = 'web_job_ad_opened'
  const payload: JobEventPayload = createJobEventPayload(job as unknown as JobItem, search, serpPositionClicked)
  sendEventToAnalytics(eventName, payload)
  countJobPageView(job ? `${job.feed}#${job.source}` : undefined)
}
